/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributesHolderIdentifier } from './AttributesHolderIdentifier';
import {
    AttributesHolderIdentifierFromJSON,
    AttributesHolderIdentifierFromJSONTyped,
    AttributesHolderIdentifierToJSON,
} from './AttributesHolderIdentifier';

/**
 * 
 * @export
 * @interface CustomMetric
 */
export interface CustomMetric {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomMetric
     */
    attributes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomMetric
     */
    customId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMetric
     */
    customYFormula?: string;
    /**
     * 
     * @type {AttributesHolderIdentifier}
     * @memberof CustomMetric
     */
    holder: AttributesHolderIdentifier;
    /**
     * 
     * @type {boolean}
     * @memberof CustomMetric
     */
    includePreview?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomMetric
     */
    lineage?: CustomMetricLineageEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomMetric
     */
    lineageEntityType?: CustomMetricLineageEntityTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CustomMetric
     */
    normalizeToFirstValue?: boolean;
}


/**
 * @export
 */
export const CustomMetricLineageEnum = {
    Full: 'FULL',
    None: 'NONE'
} as const;
export type CustomMetricLineageEnum = typeof CustomMetricLineageEnum[keyof typeof CustomMetricLineageEnum];

/**
 * @export
 */
export const CustomMetricLineageEntityTypeEnum = {
    Run: 'RUN',
    Experiment: 'EXPERIMENT'
} as const;
export type CustomMetricLineageEntityTypeEnum = typeof CustomMetricLineageEntityTypeEnum[keyof typeof CustomMetricLineageEntityTypeEnum];


/**
 * Check if a given object implements the CustomMetric interface.
 */
export function instanceOfCustomMetric(value: object): value is CustomMetric {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('customId' in value) || value['customId'] === undefined) return false;
    if (!('holder' in value) || value['holder'] === undefined) return false;
    return true;
}

export function CustomMetricFromJSON(json: any): CustomMetric {
    return CustomMetricFromJSONTyped(json, false);
}

export function CustomMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomMetric {
    if (json == null) {
        return json;
    }
    return {
        
        'attributes': json['attributes'],
        'customId': json['customId'],
        'customYFormula': json['customYFormula'] == null ? undefined : json['customYFormula'],
        'holder': AttributesHolderIdentifierFromJSON(json['holder']),
        'includePreview': json['includePreview'] == null ? undefined : json['includePreview'],
        'lineage': json['lineage'] == null ? undefined : json['lineage'],
        'lineageEntityType': json['lineageEntityType'] == null ? undefined : json['lineageEntityType'],
        'normalizeToFirstValue': json['normalizeToFirstValue'] == null ? undefined : json['normalizeToFirstValue'],
    };
}

export function CustomMetricToJSON(value?: CustomMetric | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributes': value['attributes'],
        'customId': value['customId'],
        'customYFormula': value['customYFormula'],
        'holder': AttributesHolderIdentifierToJSON(value['holder']),
        'includePreview': value['includePreview'],
        'lineage': value['lineage'],
        'lineageEntityType': value['lineageEntityType'],
        'normalizeToFirstValue': value['normalizeToFirstValue'],
    };
}

